import Form from 'antd/es/form';
import Switch from 'antd/es/switch';
import React from 'react';

interface BooleanToggleProps {
  label: string;
  name: string;
  help?: string;
  checkedChildren?: string;
  unCheckedChildren?: string;
}

export const BooleanToggle: React.FC<BooleanToggleProps> = ({
  label,
  name,
  help,
  checkedChildren = 'On',
  unCheckedChildren = 'Off',
}) => {
  return (
    <Form.Item label={label} name={name} valuePropName="checked" help={help}>
      <Switch
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
      />
    </Form.Item>
  );
};
